export const LangValidation = {
    "accepted"         : "مقدار این فیلد باید پذیرفته شده باشد.",
    "date"             : "مقدار این فیلد یک تاریخ معتبر نیست.",
    "email"            : "ایمیل معتبر در این فیلد وارد نمایید.",
    "image"            : "مقدار این فیلد باید تصویر باشد.",
    "max"              : "طول این فیلد بیش حد مجاز است.",
    "min"              : "طول این فیلد کمتر از حد مجاز است." ,
    "numeric"          : "مقدار این فیلد باید شامل عدد باشد.",
    "regex"            : "مقدار این فیلد یک فرمت معتبر نیست",
    "required"         : " مقدار این فیلد الزامی است",
    "same"             : "مقدار وارد شده با فیلد پسورد یکسان نیست",
    "unique"           : "مقدار این فیلد قبلا انتخاب شده است.",
    "exists_code"      : "کد ارسالی در سیستم وجود ندارد",
    "expire_code"      : "اعتبار کد ارسالی به پایان رسیده است",
    "used"             : "این کد قبلا مورد استفاده قرار گرفته است",
    "recaptcha"        : "کپچا اعتبار لازم را ندارد",
    "mime_type"        : "شما باید یک تصویر با فرمت jpg ، png و یا gif انتخاب نمایید",
};


// WEBPACK FOOTER //
// ./src/lang/fa/validation.js